import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=a6e57184&scoped=true"
import script from "./privacyAgreement.vue?vue&type=script&lang=js"
export * from "./privacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=a6e57184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e57184",
  null
  
)

export default component.exports